<template>
  <div>
    <ContentWrapperControl>
      <div class="bg-white p-4 rounded-b-lg shadow border-b mb-4">
        <div class="mb-2 text-md font-bold">
          <span v-text="lang('lbl_0000040') + ', '"></span>
          <span v-text="getName()"></span>!
        </div>
        <div
          v-if="this.$store.state.has_pin && this.$store.state.pin_update"
          v-text="lang('lbl_0000284')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
        <div
          v-else-if="this.$store.state.forgot_pin"
          v-text="lang('lbl_0000288')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
        <div
          v-else
          v-text="lang('lbl_0000031')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>
      <div class="bg-white p-4 rounded-lg shadow border-b">
        <div>
          <PinControl
            @typing="typing"
            @complete="complete"
            v-bind:label="lang(title)"
            v-bind:value="pin"
          />
        </div>
        <div class="px-4 pb-4 flex">
          <div class="flex-1">
            <ButtonControl v-on:click="next" v-bind:disabled="disabled">
              {{ lang(btn_label) }}
            </ButtonControl>
          </div>
        </div>
      </div>
    </ContentWrapperControl>
  </div>
</template>

<script>
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import PinControl from "./../../components/controls/PinControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    PinControl,
  },
  data() {
    return {
      confirm: false,
      disabled: true,
      pin: null,
      first_pin: null,
      title: null,
      btn_label: null,
      navbar_title: null,
    };
  },
  mounted() {
    this.$emit("checkauth", false);
    this.$emit("nofooter", true);

    let state = this.$store.state;

    if (state.pin_update || !state.has_pin) {
      this.navbar_title = this.lang("lbl_0000030");
    } else if (state.forgot_pin) {
      this.navbar_title = this.lang("lbl_0000289");
    } else {
      this.navbar_title = this.lang("lbl_0000087");
    }

    this.$emit("shownavbar", {
      title: this.navbar_title,
      show: true,
      back: false,
    });

    this.title = this.lang("lbl_0000032");
    this.btn_label = this.lang("lbl_0000033");
  },
  methods: {
    typing(value) {
      this.disabled = !(typeof value === "string" && value.length === 6);
    },
    complete(pin) {
      this.pin = pin;
    },
    getName() {
      let name = (this.$store.state.info.first_name || "").toLowerCase();

      return name.replace(/\b\w/g, (char) => char.toUpperCase());
    },
    next() {
      if (this.confirm) {
        if (this.pin == this.first_pin) {
          this.save();
        } else {
          this.pin = "";
          this.$emit("alert", {
            theme: "error",
            title: this.lang("lbl_0000034"),
            message: this.lang("lbl_0000036"),
          });
        }
      } else {
        this.$emit("showloader");
        if (
          this.$store.state.enroll.pin != null &&
          this.pin == this.$store.state.enroll.pin
        ) {
          this.pin = "";
          this.$emit("alert", {
            theme: "error",
            title: this.lang("lbl_0000034"),
            message: this.lang("lbl_0000285"),
          });
          this.$emit("hideloader");
          return;
        }
        User.testPin(this.pin)
          .then(() => {
            this.first_pin = this.pin;
            this.pin = "";
            this.confirm = true;
            this.title = this.lang("lbl_0000035");
            this.btn_label = this.lang("lbl_0000153");
            this.$emit("hideloader");
          })
          .catch((error) => {
            this.pin = "";
            this.$emit("error", error);
          });
      }
    },
    save() {
      let state = this.$store.state;
      this.$emit("showloader");
      if (state.forgot_pin) {
        User.forgotPIN(
          state.uuid,
          state.hash,
          state.reset_pin.otp_token,
          state.reset_pin.otp_pin,
          this.pin
        )
          .then(() => {
            state.forgot_pin = false;
            state.pin_login = true;
            this.makePINLoginCookie(state.hash);
            state.otp_login = true;
            this.makeOTPLoginCookie(state.hash);
            this.$emit("login");
            this.$emit("success", this.lang("lbl_0000295"));
            this.$emit("nofooter", false);
            this.$router.push("/dashboard");
          })
          .catch((error) => {
            this.$emit("error", error);
          })
          .finally(() => {
            this.$emit("hideloader");
          });
      } else {
        User.updatePin(state.uuid, state.enroll.pin, this.pin)
          .then(() => {
            state.has_pin = true;
            state.pin_login = true;
            this.makePINLoginCookie(state.hash);
            state.pin_update = false;

            if (
              state.config.find((item) => item.type === 2)?.status === true &&
              !state.otp_login
            ) {
              this.$router.push("/user/login/otp");
              return;
            }

            this.$emit("login");
            this.$emit("success", this.lang("lbl_0000154"));
            this.$emit("nofooter", false);
            this.$router.push("/dashboard");
          })
          .catch((error) => {
            this.$emit("error", error);
          })
          .finally(() => {
            this.$emit("hideloader");
          });
      }
    },
    logout() {
      this.$emit("showloader");
      User.logout()
        .then(() => {
          this.destroyCookies();
          this.resetUserData();
          this.$emit("logout");
          this.$emit("hideloader");
          this.$router.push("/");
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
  },
};
</script>
